import { parseAsFloat } from 'nuqs/server'

export const paginationParsers = {
  skip: parseAsFloat.withDefault(0),
  take: parseAsFloat.withDefault(24),
}
